/**
 * Вызов цели Яндекс Метрики
 * @param name
 */
const ymReachGoal = name => {
	window && window.ym && window.ym(57442858, 'reachGoal', name)
}

export default ymReachGoal
